import type { TLead } from './lead';
import type { TMedia } from './media';
import type { TMemberMini } from './member';
import type { ValueOf } from './utilities';

export const LEAD_NOTE_CHANNELS = {
  office: 'OFFICE',
  call: 'CALL',
  whatsapp: 'WHATSAPP',
  email: 'EMAIL',
  other: 'OTHER',
} as const;

export const LEAD_NOTE_STATUS = {
  today: 'TODAY',
  upcoming: 'UPCOMING',
  complete: 'COMPLETE',
  overdue: 'OVERDUE',
} as const;

export type TLeadNote = {
  id: number;
  lead: TLead;
  note: string;

  // creator / resolver info
  created_by: TMemberMini;
  created_by_partner?: TMemberMini;
  resolved_by_partner?: TMemberMini;

  // timestamps & status
  created_at: string;
  updated_at: string;
  status?: ValueOf<typeof LEAD_NOTE_STATUS>;

  // follow-up & channel
  next_follow_up_date?: string;
  channel?: ValueOf<typeof LEAD_NOTE_CHANNELS>;

  // organization & attachments
  organization: number;
  attachments: TMedia[];

  // resolved info
  resolved_by?: TMemberMini;
  resolved_at?: string;
  is_resolved?: boolean;
};
